import { useCallback, useState } from "react";
import { API_URL } from "src/util/config";
import { checkResponse } from "src/util/helpers";
import { useAuth } from "src/contexts/AuthContext";
import { AcquisitionSubsidiaryOption } from "models/acquisition-import";

export const useAcquisitionSubsidiaries = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [items, setItems] = useState<AcquisitionSubsidiaryOption[]>([]);
  const { fetchWithReauth } = useAuth();

  const loadSubsidiaries = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetchWithReauth(
        `${API_URL}/acquisition-imports/subsidiaries`,
        { method: "GET" }
      );
      const data = (await checkResponse(response)) as {
        items?: AcquisitionSubsidiaryOption[];
      };
      setItems(data.items || []);
    } catch (err) {
      const message =
        err instanceof Error
          ? err.message
          : "Failed to load subsidiaries from NetSuite.";
      setError(message);
      setItems([]);
      console.error("Error loading subsidiaries:", err);
    } finally {
      setLoading(false);
    }
  }, [fetchWithReauth]);

  return { items, loading, error, loadSubsidiaries };
};
